import "./index.css";
// src/PromptInput/PromptInput.tsx
import PromptInputComponent from "@cloudscape-design/components/prompt-input";
import Box3 from "@cloudscape-design/components/box";
import SpaceBetween4 from "@cloudscape-design/components/space-between";
import Link2 from "@cloudscape-design/components/link";
import FormField from "@cloudscape-design/components/form-field";
import FileInput from "@cloudscape-design/components/file-input";
import FileDropzone, { useFilesDragging } from "@cloudscape-design/components/file-dropzone";
import Icon from "@cloudscape-design/components/icon";
import FileTokenGroup from "@cloudscape-design/components/file-token-group";
import Spinner2 from "@cloudscape-design/components/spinner";
import * as React from "react";
import { ContentBlockVisibility, ACCEPTED_EXTENSIONS_STRING, validateFiles } from "@amzn/awsmp-max-model";
import { useAppTranslation as useAppTranslation3, AppTrans as AppTrans3 } from "@amzn/awsmp-max-translations";

// src/DisclaimerModal/AwsTermsDisclaimerModal.tsx
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import TextContent from "@cloudscape-design/components/text-content";
import Link from "@cloudscape-design/components/link";
import { useAppTranslation, AppTrans } from "@amzn/awsmp-max-translations";
import { jsx, jsxs } from "react/jsx-runtime";
var AwsTermsDisclaimerModal = ({ visible, onDismiss }) => {
  const { t } = useAppTranslation();
  return /* @__PURE__ */ jsx(
    Modal,
    {
      size: "medium",
      onDismiss,
      visible,
      header: t("disclaimer"),
      footer: /* @__PURE__ */ jsx(Box, { float: "right", children: /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: onDismiss, children: t("close") }) }),
      "data-testid": "aws-terms-disclaimer-modal",
      children: /* @__PURE__ */ jsx(SpaceBetween, { direction: "vertical", size: "m", children: /* @__PURE__ */ jsx(TextContent, { children: /* @__PURE__ */ jsxs(AppTrans, { i18nKey: "disclaimerModalContent", children: [
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/terms/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/aup/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/ai/responsible-ai/policy/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/privacy/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/terms/" })
      ] }) }) })
    }
  );
};

// src/DisclaimerModal/AiContentDisclaimerModal.tsx
import Modal2 from "@cloudscape-design/components/modal";
import Box2 from "@cloudscape-design/components/box";
import Button2 from "@cloudscape-design/components/button";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import TextContent2 from "@cloudscape-design/components/text-content";
import { useAppTranslation as useAppTranslation2, AppTrans as AppTrans2 } from "@amzn/awsmp-max-translations";
import { jsx as jsx2 } from "react/jsx-runtime";

// src/PromptInput/PromptInput.module.scss
var PromptInput_module_default = {
  AskAgentModeLabel: "PromptInput_module_AskAgentModeLabel2",
  SecondaryContentWrapper: "PromptInput_module_SecondaryContentWrapper2",
  FooterContainer: "PromptInput_module_FooterContainer2",
  FooterLinksContainer: "PromptInput_module_FooterLinksContainer2",
  SecondaryActionsContainer: "PromptInput_module_SecondaryActionsContainer2",
  FileInputDisabledWrapper: "PromptInput_module_FileInputDisabledWrapper2",
  SecondaryActionsPadding: "PromptInput_module_SecondaryActionsPadding2",
  LightGreyText: "PromptInput_module_LightGreyText2",
  StatusContainer: "PromptInput_module_StatusContainer2",
  StatusText: "PromptInput_module_StatusText2",
  StatusTextError: "PromptInput_module_StatusTextError2",
  RedesignDropzone: "PromptInput_module_RedesignDropzone2"
};

// src/PromptInput/StatusMessage.tsx
import Alert from "@cloudscape-design/components/alert";
import SpaceBetween3 from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var StatusMessage = ({ type, message, onDismiss }) => {
  if (type === "error") {
    return /* @__PURE__ */ jsx3(Alert, { type: "error", dismissible: !!onDismiss, onDismiss, children: message });
  }
  return /* @__PURE__ */ jsx3(Alert, { type: "info", dismissible: false, children: /* @__PURE__ */ jsxs2(SpaceBetween3, { direction: "horizontal", size: "xs", alignItems: "center", children: [
    /* @__PURE__ */ jsx3(Spinner, {}),
    /* @__PURE__ */ jsx3("span", { children: message })
  ] }) });
};

// src/assets/agent-mode-icon.svg
var agent_mode_icon_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 9.375C0.00273 11.8606 0.99133 14.2435 2.74889 16.0011C4.50645 17.7587 6.88943 18.7473 9.375 18.75H17.2809C17.6704 18.7495 18.0438 18.5946 18.3192 18.3192C18.5946 18.0438 18.7495 17.6704 18.75 17.2809V9.375C18.75 6.8886 17.7623 4.50403 16.0041 2.74587C14.246 0.98772 11.8614 0 9.375 0C6.8886 0 4.50403 0.98772 2.74587 2.74587C0.98772 4.50403 0 6.8886 0 9.375Z" fill="url(%23homeAgentIconGrad)"></path><path d="M9.3346 4.58203C9.1635 4.58203 9.0098 4.68665 8.947 4.84583L7.8349 7.66564L5.0151 8.77778C4.85592 8.84054 4.7513 8.99429 4.7513 9.16539C4.7513 9.33649 4.85592 9.49024 5.0151 9.55299L7.8349 10.6651L8.947 13.4849C9.0098 13.6441 9.1635 13.7487 9.3346 13.7487C9.5057 13.7487 9.6595 13.6441 9.7222 13.4849L10.8344 10.6651L13.6542 9.55299C13.8134 9.49024 13.918 9.33649 13.918 9.16539C13.918 8.99429 13.8134 8.84054 13.6542 8.77778L10.8344 7.66564L9.7222 4.84583C9.6595 4.68665 9.5057 4.58203 9.3346 4.58203Z" fill="white"></path><defs><radialGradient id="homeAgentIconGrad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.4235 -1.67354) rotate(134.492) scale(39.845 50.9814)"><stop stop-color="%238376FE"></stop><stop offset="0.21" stop-color="%235C7FFF"></stop><stop offset="0.4" stop-color="%238575FF"></stop><stop offset="0.68" stop-color="%23962EFF"></stop></radialGradient></defs></svg>%0A';

// src/PromptInput/PromptInput.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var CloudscapePromptInput = PromptInputComponent;
var PromptInput = React.forwardRef(
  ({ lines = 1, placeholderText, onSubmit, isDisabled, loading, promptInputAction, logger, isRedesignEnabled = false, isEmbedded = false }, ref) => {
    const { t } = useAppTranslation3();
    const maxLength = 4e3;
    const { areFilesDragging } = useFilesDragging();
    const [value, setValue] = React.useState("");
    const [disclaimerVisible, setDisclaimerVisible] = React.useState(false);
    const [files, setFiles] = React.useState([]);
    const [uploadProgress, setUploadProgress] = React.useState({});
    const [uploadErrors, setUploadErrors] = React.useState({});
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [templateVisibility, setTemplateVisibility] = React.useState(void 0);
    const internalRef = React.useRef(null);
    const inputRef = ref || internalRef;
    const prevDisabledRef = React.useRef(isDisabled);
    const disableSend = !value.trim() && files.length === 0 || value.length > maxLength;
    const handleFileChange = React.useCallback(
      (newFiles) => {
        const validFiles = [];
        const errors = {};
        newFiles.forEach((file) => {
          const validation = validateFiles([file]);
          if (!validation.isValid) {
            errors[file.name] = validation.errors.join(". ");
          } else {
            validFiles.push(file);
          }
        });
        if (validFiles.length > 0) {
          setFiles((prev) => [...prev, ...validFiles]);
        }
        if (Object.keys(errors).length > 0) {
          const invalidFiles = newFiles.filter((f) => errors[f.name]);
          setFiles((prev) => [...prev, ...invalidFiles]);
          setUploadErrors((prev) => ({ ...prev, ...errors }));
        }
      },
      [setFiles, setUploadErrors]
    );
    React.useEffect(() => {
      if (prevDisabledRef.current === true && isDisabled === false) {
        inputRef.current?.focus();
      }
      prevDisabledRef.current = isDisabled;
    }, [isDisabled, inputRef]);
    React.useEffect(() => {
      const action = promptInputAction?.action;
      const consume = promptInputAction?.consume;
      if (action && inputRef.current) {
        if (action.type === "insert-text") {
          setValue(action.text);
          if (action.visibility) {
            setTemplateVisibility(action.visibility);
          }
          setTimeout(() => {
            if (inputRef.current && action.selectionStart !== void 0 && action.selectionEnd !== void 0) {
              inputRef.current.setSelectionRange(action.selectionStart, action.selectionEnd);
            }
            inputRef.current?.focus();
          }, 0);
        }
        consume?.();
      }
    }, [promptInputAction, inputRef]);
    const handleSubmit = React.useCallback(() => {
      try {
        setError(null);
        console.log("Logger", logger);
        logger?.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "send-message-button"
          }
        });
        if (disableSend) {
          return;
        }
        const hadFilesToUpload = files.length > 0;
        const uploadedFileNames = files.map((f) => f.name);
        let messageContent = value.trim();
        if (!messageContent && hadFilesToUpload) {
          messageContent = t("analyzeUploadedFiles", {
            plural: uploadedFileNames.length > 1 ? "s" : "",
            files: uploadedFileNames.join(", ")
          });
        }
        const contentBlocks = [];
        if (messageContent) {
          const isAutoGenerated = !value.trim() && hadFilesToUpload;
          contentBlocks.push({
            text: value.trim() || messageContent,
            visibility: templateVisibility ?? (isAutoGenerated ? ContentBlockVisibility.INFERENCE_ONLY : void 0)
          });
        }
        const uploadCallbacks = {
          onProgress: (fileName, percent) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: percent }));
          },
          onSuccess: (fileName) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: 100 }));
            setFiles((prev) => prev.filter((f) => f.name !== fileName));
          },
          onError: (fileName, errorMsg) => {
            setUploadErrors((prev) => ({ ...prev, [fileName]: errorMsg }));
          },
          onProcessing: () => {
            setIsProcessing(true);
          },
          onComplete: () => {
            setIsProcessing(false);
          }
        };
        onSubmit({
          contentBlocks,
          files,
          uploadCallbacks
        });
        setValue("");
        setTemplateVisibility(void 0);
      } catch (err) {
        setError(err instanceof Error ? err.message : t("failedToSendMessage"));
      }
    }, [onSubmit, files, value, disableSend, templateVisibility, logger, t]);
    const getStatusMessage = () => {
      const uploadingFiles = Object.keys(uploadProgress).filter((fileName) => uploadProgress[fileName] < 100);
      const errorFiles = Object.keys(uploadErrors);
      if (errorFiles.length > 0) {
        return {
          type: "error",
          message: t("failedToUploadFiles", {
            count: errorFiles.length,
            plural: errorFiles.length > 1 ? "s" : ""
          })
        };
      }
      if (isProcessing) {
        return {
          type: "updating",
          message: t("scanningFiles")
        };
      }
      if (uploadingFiles.length > 0) {
        return {
          type: "updating",
          message: t("uploadingFiles")
        };
      }
      return null;
    };
    const statusMessage = getStatusMessage();
    const spinnerPriority = React.useMemo(() => {
      if (statusMessage && statusMessage.type === "updating") {
        return "file-upload";
      }
      if (loading) {
        return "send-message";
      }
      return null;
    }, [statusMessage, loading]);
    const isUploading = Object.values(uploadProgress).some((progress) => progress < 100);
    return /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "s", children: [
      error && /* @__PURE__ */ jsx4(StatusMessage, { type: "error", message: error, onDismiss: () => setError(null) }),
      /* @__PURE__ */ jsx4(
        FormField,
        {
          stretch: true,
          className: PromptInput_module_default.FormFieldPadding,
          "data-testid": "standard-layout-form-field",
          constraintText: /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.FooterContainer, "data-testid": "standard-layout-footer", children: [
            !isRedesignEnabled && /* @__PURE__ */ jsx4("span", { "data-testid": "standard-layout-disclaimer", children: /* @__PURE__ */ jsxs3(AppTrans3, { i18nKey: "promptAgreeToDisclaimer", children: [
              /* @__PURE__ */ jsx4(Link2, { variant: "primary", onFollow: () => setDisclaimerVisible(true), "data-testid": "standard-layout-disclaimer-link" }),
              /* @__PURE__ */ jsx4("br", {})
            ] }) }),
            " ",
            /* @__PURE__ */ jsx4("span", { "data-testid": "standard-layout-character-count", children: t(isRedesignEnabled ? "characterCountCompact" : "characterCount", { current: value.length, max: maxLength }) })
          ] }),
          errorText: value.length > maxLength && t("promptTooManyCharacters"),
          children: /* @__PURE__ */ jsx4(
            CloudscapePromptInput,
            {
              ref: inputRef,
              "data-testid": "standard-layout-prompt-input",
              onChange: ({ detail }) => setValue(detail.value),
              disabled: isDisabled || isUploading || isProcessing || loading,
              disableActionButton: disableSend || loading,
              onAction: handleSubmit,
              value,
              actionButtonAriaLabel: loading ? t("sending") : t("sendMessage"),
              actionButtonIconName: loading ? void 0 : "send",
              actionButtonIconSvg: spinnerPriority === "send-message" ? /* @__PURE__ */ jsx4(Spinner2, { size: "normal", "data-testid": "action-button-spinner" }) : void 0,
              placeholder: placeholderText,
              minRows: lines,
              disableSecondaryActionsPaddings: true,
              secondaryActions: /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.SecondaryActionsContainer, "data-testid": "standard-layout-secondary-actions", children: [
                /* @__PURE__ */ jsx4(
                  "div",
                  {
                    className: isRedesignEnabled && (isDisabled || isUploading || isProcessing || loading) ? PromptInput_module_default.FileInputDisabledWrapper : void 0,
                    children: /* @__PURE__ */ jsx4(
                      FileInput,
                      {
                        className: isRedesignEnabled ? PromptInput_module_default.RedesignDropzone : void 0,
                        variant: isRedesignEnabled ? "button" : "icon",
                        ariaLabel: isRedesignEnabled ? void 0 : t("uploadFiles"),
                        multiple: true,
                        value: files,
                        accept: ACCEPTED_EXTENSIONS_STRING,
                        onChange: ({ detail }) => {
                          detail.value.forEach((file) => {
                            logger?.biMetric({
                              metricName: "Click",
                              value: 1,
                              unit: "Count",
                              dimensions: {
                                ClickSelect: "file-upload-button",
                                ClickAct: `${file.size}`
                              }
                            });
                          });
                          handleFileChange(detail.value);
                        },
                        "data-testid": "standard-layout-file-input",
                        children: isRedesignEnabled ? t("dropRequirementsOrRfps") : void 0
                      }
                    )
                  }
                ),
                statusMessage && /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.StatusContainer, children: [
                  spinnerPriority === "file-upload" && /* @__PURE__ */ jsx4(Spinner2, { size: "normal" }),
                  /* @__PURE__ */ jsx4("span", { className: statusMessage.type === "error" ? PromptInput_module_default.StatusTextError : PromptInput_module_default.StatusText, children: statusMessage.message })
                ] })
              ] }),
              secondaryContent: isEmbedded || files.length > 0 || areFilesDragging ? /* @__PURE__ */ jsx4("div", { className: isEmbedded ? PromptInput_module_default.SecondaryContentWrapper : void 0, children: /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "xs", children: [
                isEmbedded && /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.AskAgentModeLabel, "data-testid": "ask-agent-mode-label", children: [
                  /* @__PURE__ */ jsx4(Icon, { url: agent_mode_icon_default, alt: "" }),
                  /* @__PURE__ */ jsx4("span", { children: t("askAgentMode") })
                ] }),
                areFilesDragging ? /* @__PURE__ */ jsx4(FileDropzone, { onChange: ({ detail }) => handleFileChange(detail.value), "data-testid": "standard-layout-file-dropzone", children: /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "xs", alignItems: "center", children: [
                  /* @__PURE__ */ jsx4(Icon, { name: "upload", "data-testid": "standard-layout-upload-icon" }),
                  /* @__PURE__ */ jsx4(Box3, { "data-testid": "standard-layout-drop-text", children: t("dropFilesHere") })
                ] }) }) : files.length > 0 ? /* @__PURE__ */ jsx4(
                  FileTokenGroup,
                  {
                    "data-testid": "standard-layout-file-tokens",
                    items: files.map((file) => {
                      const progress = uploadProgress[file.name];
                      const error2 = uploadErrors[file.name];
                      return {
                        file,
                        loading: progress !== void 0 && progress < 100,
                        errorText: error2
                      };
                    }),
                    onDismiss: ({ detail }) => {
                      const removedFile = files[detail.fileIndex];
                      setFiles((files2) => files2.filter((_, index) => index !== detail.fileIndex));
                      setUploadErrors((prev) => {
                        const newErrors = { ...prev };
                        delete newErrors[removedFile.name];
                        return newErrors;
                      });
                    },
                    alignment: "horizontal",
                    showFileSize: true,
                    showFileLastModified: true,
                    showFileThumbnail: true,
                    i18nStrings: {
                      removeFileAriaLabel: () => t("removeFile"),
                      limitShowFewer: t("showFewerFiles"),
                      limitShowMore: t("showMoreFiles"),
                      errorIconAriaLabel: t("errorIconAriaLabel"),
                      warningIconAriaLabel: t("warningIconAriaLabel")
                    }
                  }
                ) : null
              ] }) }) : void 0
            }
          )
        }
      ),
      !isRedesignEnabled && /* @__PURE__ */ jsx4(AwsTermsDisclaimerModal, { visible: disclaimerVisible, onDismiss: () => setDisclaimerVisible(false) })
    ] });
  }
);
PromptInput.displayName = "PromptInput";
export {
  PromptInput
};
//# sourceMappingURL=index.js.map
